import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';

/**
 * Domain model representing a single call record from the Calls collection.
 * Based on the Calls interface in mobile
 */
export default class Call {
    private _id: string;
    private _created: number;
    private _customer: string;
    private _duration: number;
    private _idApiKey: string;
    private _idContact: string;
    private _platform: string;
    private _price: number;
    private _sender: string;
    private _transcription: string;
    private _transcriptionSrt: string;
    private _transcriptionRaw: string;
    private _direction: string;
    private _missed: boolean;
    private _readedFrontend: boolean;
    private _hidden: boolean;

    constructor(
        id: string,
        created: number,
        customer: string,
        duration: number,
        idApiKey: string,
        idContact: string,
        platform: string,
        price: number,
        sender: string,
        transcription: string,
        transcriptionSrt: string,
        transcriptionRaw: string,
        direction: string,
        missed: boolean,
        readedFrontend: boolean,
        hidden: boolean,
    ) {
        this._id = id;
        this._created = created;
        this._customer = customer;
        this._duration = duration;
        this._idApiKey = idApiKey;
        this._idContact = idContact;
        this._platform = platform;
        this._price = price;
        this._sender = sender;
        this._transcription = transcription;
        this._transcriptionSrt = transcriptionSrt;
        this._transcriptionRaw = transcriptionRaw;
        this._direction = direction;
        this._missed = missed;
        this._readedFrontend = readedFrontend;
        this._hidden = hidden;
    }

    get id(): string {
        return this._id;
    }

    get created(): number {
        return this._created;
    }

    get customer(): string {
        return this._customer;
    }

    get duration(): number {
        return this._duration;
    }

    get idApiKey(): string {
        return this._idApiKey;
    }

    get idContact(): string {
        return this._idContact;
    }

    get platform(): string {
        return this._platform;
    }

    get price(): number {
        return this._price;
    }

    get sender(): string {
        return this._sender;
    }

    get transcription(): string {
        return this._transcription;
    }

    get transcriptionSrt(): string {
        return this._transcriptionSrt;
    }

    get transcriptionRaw(): string {
        return this._transcriptionRaw;
    }

    get direction(): string {
        return this._direction;
    }

    get missed(): boolean {
        return this._missed;
    }

    get readedFrontend(): boolean {
        return this._readedFrontend;
    }

    get hidden(): boolean {
        return this._hidden;
    }

    static fromFirestore(
        doc: QueryDocumentSnapshot<DocumentData, DocumentData>
    ): Call {
        const data = doc.data();

        return new Call(
            doc.id,
            data.created ?? 0,
            data.customer ?? '',
            data.duration ?? 0,
            data.id_api_key ?? '',
            data.id_contact ?? '',
            data.platform ?? '',
            data.price ?? 0,
            data.sender ?? '',
            data.transcription ?? '',
            data.transcription_srt ?? '',
            data.transcription_raw ?? '',
            data.direction ?? '',
            data.missed ?? false,
            data.readed_frontend ?? false,
            data.hidden ?? false,
        );
    }

    toFirestorePatch(): Record<string, unknown> {
        return {
            created: this._created,
            customer: this._customer,
            duration: this._duration,
            id_api_key: this._idApiKey,
            id_contact: this._idContact,
            platform: this._platform,
            price: this._price,
            sender: this._sender,
            transcription: this._transcription,
            transcription_srt: this._transcriptionSrt,
            transcription_raw: this._transcriptionRaw,
            direction: this._direction,
            missed: this._missed,
            readed_frontend: this._readedFrontend,
            hidden: this._hidden,
        };
    }
}

